// extracted by mini-css-extract-plugin
module.exports = {"book":"Links_book__3-_p_","sample":"Links_sample__objym","wrapper":"Links_wrapper__2_5ua","cover":"Links_cover__XrWWd","image":"Links_image__1_H5x"};